import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { SongViewer, type ViewerSong } from '@/components/ui/cifras/song-viewer';
import { Content } from '@/components/ui/content';
import { useRouter } from '@/hooks/use-router';
import { meta } from '@/lib/meta';
import { useSong } from '@/services/songs';

export const Route = createFileRoute('/_app/songs/$id/view')({
  head: () => meta({ label: 'Cifra' }),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { push } = useRouter();
  const { data } = useSong({ id });

  const songs = useMemo<ViewerSong[]>(
    () =>
      data
        ? [
            {
              id: data.id,
              title: data.title,
              originalKey: data.originalKey,
              capo: data.capo,
              notes: data.notes,
              content: data.content,
              artist: data.artist?.name ?? null,
              key: null,
            },
          ]
        : [],
    [data],
  );

  return (
    <Content
      isLoading={!data}
      breadcrumbs={{
        icon: 'music',
        title: data?.title ?? 'Cifra',
        items: [
          { label: 'Cifras', route: '/songs' },
          { label: 'Palco', active: true },
        ],
      }}
    >
      {data && (
        <SongViewer
          key={data.id}
          songs={songs}
          onPrint={() => push(`/songs/${id}/print`)}
        />
      )}
    </Content>
  );
}
